export const SEGMENT_COLORS: Record<string, string> = {
    regular: "hsl(var(--chart-3))",
    break: "hsl(var(--chart-4))",
    overtime: "hsl(var(--destructive))",
};

export const SEGMENT_TYPES = ["regular", "overtime", "break"] as const;
